import { Button } from '@/components/design-system/Button';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import { SaveOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface SaveLayoutButtonProps {
  onSave: () => void;
  isSaving: boolean;
  disabled?: boolean;
  'data-testid'?: string;
}

export const SaveLayoutButton = ({
  onSave,
  isSaving,
  disabled = false,
  'data-testid': dataTestId = 'save-layout-button'
}: SaveLayoutButtonProps) => {
  const { t } = useTranslation();
  const handleClick = useDebouncedCallback(onSave, 1000);

  return (
    <Button
      variant="default"
      size="sm"
      className="border-border-100"
      onClick={handleClick}
      disabled={disabled || isSaving}
      data-testid={dataTestId}
    >
      <SaveOutlined className={isSaving ? 'animate-pulse' : ''} />
      {t('grid.layout.save')}
    </Button>
  );
};
